module.exports = __webpack_public_path__ + "img/8.606d899d.svg";